import { AttachmentFragment } from '@spotify/confidence-graphql';

export const isExternalLink = (uri: string): boolean =>
  /^https?:\/\//i.test(uri);

export const isExternalDocument = (uri: string): boolean =>
  uri.replace(/^\/\//, '').startsWith('externalDocuments/');

export const isContextArtifact = (artifact: AttachmentFragment): boolean =>
  isExternalLink(artifact.uri) || isExternalDocument(artifact.uri);
